import fail from '../../../assets/images/failIcon.svg';
import { closePopup } from '../../../store/slices/popupSlice';
import { useAppDispatch } from '../../../store/store';
import RedButton from '../../ui/buttons/redButton/RedButton';
import styles from './styles/styles.module.css';

function TopUpFailPopup() {
  const dispatch = useAppDispatch();

  const handleClosePopup = () => {
    dispatch(closePopup());
  };

  return (
    <div className={styles.failPopupWrapper}>
      <button
        className={styles.closePopupButton}
        onClick={handleClosePopup}
        aria-label="Закрыть"
      />
      <div className={styles.failTextWrapper}>
        <img src={fail} alt="иконка красный крестик" />
        <h2 className={styles.failTitle}>Не удалось пополнить баланс!</h2>
        <p className={styles.failText}>Попробуйте пополнить баланс позже</p>
      </div>
      <RedButton text="Продолжить" onClick={handleClosePopup} width={308} height={50} />
    </div>
  );
}

export default TopUpFailPopup;
